export default __webpack_public_path__ + "b3a47bf30ecfd5604cf84f2a8e4783ee.webp";